module.exports = __webpack_public_path__ + "img/strikethrough-01.3580c34f.svg";